import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { useLang } from "@/lib/i18n";

export const SERVICES = [
  {
    id: "carpet",
    num: "01",
    title: "Carpet Installation",
    titleEs: "Instalación de Alfombra",
    desc: "Plush, stain-resistant carpet stretched and finished right. Pad quoted separately, stairs priced per step ($15–$30).",
    descEs: "Alfombra suave y resistente, estirada y terminada correctamente. El pad se cotiza aparte; escaleras por escalón ($15–$30).",
    badge: "Pad Quoted Apart",
    badgeEs: "Pad Aparte",
    price: "$9 – $13.50 / sq yd",
    low: 9,
    high: 13.5,
    img: "https://images.unsplash.com/photo-1560185893-a55cbc8c57e8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTV8MHwxfHNlYXJjaHw0fHxtb2Rlcm4lMjBpbnRlcmlvciUyMGhhcmR3b29kJTIwY2FycGV0JTIwZmxvb3JpbmclMjByb29tfGVufDB8fHx8MTc4OTc2MjcxNXww&ixlib=rb-4.1.0&q=85",
    span: "md:col-span-7",
  },
  {
    id: "lvp",
    num: "02",
    title: "Vinyl Plank / LVP",
    titleEs: "Vinyl Plank / LVP",
    desc: "100% waterproof luxury vinyl plank for kitchens, basements and high-moisture spaces — beauty without the worry.",
    descEs: "Vinyl de lujo 100% resistente al agua para cocinas, sótanos y zonas húmedas — belleza sin preocupaciones.",
    badge: "100% Waterproof",
    badgeEs: "100% Resistente al Agua",
    price: "$18 – $27 / sq yd",
    low: 18,
    high: 27,
    img: "/job-c.webp",
    pos: "center 75%",
    span: "md:col-span-5",
  },
  {
    id: "glue_down",
    num: "03",
    title: "Glue-Down Vinyl / Carpet",
    titleEs: "Vinyl / Alfombra Pegada",
    desc: "Ultra-secure glue-down installation for offices, rentals and high-foot-traffic areas, built for long-term wear.",
    descEs: "Instalación pegada ultra segura para oficinas, rentas y zonas de mucho tráfico, hecha para durar.",
    badge: "Commercial Grade",
    badgeEs: "Grado Comercial",
    price: "$18 – $27 / sq yd",
    low: 18,
    high: 27,
    img: "https://images.unsplash.com/photo-1649083048770-82e8ffd80431?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTV8MHwxfHNlYXJjaHwzfHxtb2Rlcm4lMjBpbnRlcmlvciUyMGhhcmR3b29kJTIwY2FycGV0JTIwZmxvb3JpbmclMjByb29tfGVufDB8fHx8MTc4OTc2MjcxNXww&ixlib=rb-4.1.0&q=85",
    span: "md:col-span-5",
  },
  {
    id: "vinyl_sheet",
    num: "04",
    title: "Vinyl Sheet Installation",
    titleEs: "Instalación de Vinyl Sheet",
    desc: "Smooth, seamless sheet vinyl for bathrooms, kitchens and laundry rooms. Extra seams or heavy cutting quoted on site.",
    descEs: "Hoja de vinil lisa y sin uniones para baños, cocinas y lavanderías. Uniones extra o muchos cortes se cotizan en el lugar.",
    badge: "Seamless Finish",
    badgeEs: "Acabado sin Uniones",
    price: "$18 – $27 / sq yd",
    low: 18,
    high: 27,
    img: "https://images.pexels.com/photos/15743373/pexels-photo-15743373.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    span: "md:col-span-7",
  },
  {
    id: "laminate",
    num: "05",
    title: "Laminate Flooring",
    titleEs: "Piso Laminado",
    desc: "Scratch-resistant planks with realistic wood grain and sound-dampening underlayment, built for heavy traffic.",
    descEs: "Tablas resistentes a rayones con veta de madera realista y base que reduce el sonido, hechas para mucho tráfico.",
    badge: "High Traffic",
    badgeEs: "Mucho Tráfico",
    price: "$18 – $27 / sq yd",
    low: 18,
    high: 27,
    img: "https://images.pexels.com/photos/368754/pexels-photo-368754.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    span: "md:col-span-6",
  },
  {
    id: "repair",
    num: "06",
    title: "Flooring Repair & Restoration",
    titleEs: "Reparación y Restauración de Pisos",
    desc: "Seam repair, plank replacement, subfloor leveling and water-damage patching that disappears into the original floor.",
    descEs: "Reparación de uniones, cambio de tablas, nivelación del piso y parches por daño de agua que desaparecen en el piso original.",
    badge: "Expert Craft",
    badgeEs: "Trabajo Experto",
    price: "$27 – $45 / sq yd",
    low: 27,
    high: 45,
    img: "https://images.unsplash.com/photo-1716315325541-776e39f9725f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzd8MHwxfHNlYXJjaHw0fHxmbG9vcmluZyUyMGluc3RhbGxhdGlvbiUyMGNyYWZ0c21hbiUyMGNhcnBldCUyMHdvb2QlMjBwbGFuayUyMHRleHR1cmV8ZW58MHx8fHwxNzg5NzYyNzE4fDA&ixlib=rb-4.1.0&q=85",
    span: "md:col-span-6",
  },
  {
    id: "restretch",
    num: "07",
    title: "Carpet Restretching",
    titleEs: "Re-estirado de Alfombra",
    desc: "Power-stretching that erases wrinkles, waves and trip hazards. Add seam repair at a combined rate.",
    descEs: "Estirado profesional que elimina arrugas, olas y riesgos de tropiezo. Agrega reparación de costuras a tarifa combinada.",
    badge: "Safety & Finish",
    badgeEs: "Seguridad y Acabado",
    price: "$6.75 – $11.25 / sq yd",
    low: 6.75,
    high: 11.25,
    img: "https://images.unsplash.com/photo-1560185893-a55cbc8c57e8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTV8MHwxfHNlYXJjaHw0fHxtb2Rlcm4lMjBpbnRlcmlvciUyMGhhcmR3b29kJTIwY2FycGV0JTIwZmxvb3JpbmclMjByb29tfGVufDB8fHx8MTc4OTc2MjcxNXww&ixlib=rb-4.1.0&q=85",
    span: "md:col-span-12",
  },
];

export default function Services({ onQuoteService }) {
  const { t, lang } = useLang();
  return (
    <section
      id="services"
      className="py-16 sm:py-24 lg:py-32 bg-[#FAF8F5]"
      data-testid="services-section"
    >
      <div className="px-4 sm:px-8 lg:px-12 max-w-7xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7 }}
          className="max-w-2xl mb-14"
        >
          <p className="font-mono text-xs uppercase tracking-[0.25em] text-[#F26522] font-semibold mb-4">
            {t("services_eyebrow")}
          </p>
          <h2 className="font-display text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-[#0F172A]">
            {t("services_h")}
          </h2>
          <p className="mt-4 text-base sm:text-lg leading-relaxed text-[#475569]">
            {t("services_sub")}
          </p>
          <p className="md:hidden mt-4 font-mono text-[11px] uppercase tracking-[0.2em] text-[#F26522]" data-testid="services-swipe-hint">
            {t("services_swipe")} →
          </p>
        </motion.div>

        <div
          className="flex md:grid md:grid-cols-12 gap-4 md:gap-6 lg:gap-8 overflow-x-auto md:overflow-visible snap-x snap-mandatory -mx-4 px-4 md:mx-0 md:px-0 pb-4 md:pb-0 scrollbar-none"
          data-testid="services-grid"
        >
          {SERVICES.map((s, idx) => (
            <motion.article
              key={s.id}
              initial={{ opacity: 0, y: 32 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.6, delay: (idx % 3) * 0.12 }}
              whileHover={{ y: -6 }}
              className={`group relative overflow-hidden rounded-3xl bg-white border border-[#E2E8F0] shadow-sm hover:shadow-2xl transition-shadow duration-300 shrink-0 w-[82vw] max-w-sm md:w-auto md:max-w-none snap-center ${s.span}`}
              data-testid={`service-card-${s.id}`}
            >
              <div className="relative h-40 sm:h-52 overflow-hidden">
                <img
                  src={s.img}
                  alt={`${s.title} — example flooring work`}
                  loading="lazy"
                  style={s.pos ? { objectPosition: s.pos } : undefined}
                  className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#0E1A2B]/70 via-transparent to-transparent" />
                <span className="absolute top-4 left-4 font-mono text-xs font-bold text-white/90 tracking-[0.2em]">
                  {s.num}
                </span>
                <span className="absolute bottom-4 left-4 rounded-full bg-[#F26522] px-3 py-1 font-mono text-[10px] uppercase tracking-[0.15em] font-bold text-white">
                  {lang === "es" ? s.badgeEs : s.badge}
                </span>
              </div>
              <div className="p-6 sm:p-8">
                <div className="flex items-start justify-between gap-4">
                  <h3 className="font-display text-xl sm:text-2xl font-bold text-[#0E1A2B]">
                    {lang === "es" ? s.titleEs : s.title}
                  </h3>
                  <button
                    onClick={() => onQuoteService(s.id)}
                    aria-label={`Get a quote for ${s.title}`}
                    className="shrink-0 rounded-full border border-[#E2E8F0] p-2.5 text-[#0E1A2B] transition-[background-color,color,border-color,transform] duration-200 hover:bg-[#F26522] hover:border-[#F26522] hover:text-white hover:rotate-45"
                    data-testid={`service-quote-btn-${s.id}`}
                  >
                    <ArrowUpRight className="h-5 w-5" />
                  </button>
                </div>
                <p className="mt-3 text-sm sm:text-base leading-relaxed text-[#475569]">
                  {lang === "es" ? s.descEs : s.desc}
                </p>
                <p className="mt-4 font-mono text-xs font-bold uppercase tracking-[0.15em] text-[#F26522]">
                  {s.price}
                </p>
              </div>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}
